import { ExternalLink } from 'components/styled';
import { MouseEvent, ReactNode } from 'react';

type FranchiseReportsLinkProps = {
  href: string;
  children: ReactNode;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

/**
 * Link to a franchise's numbers in Reporting Web (ADM-40), opened in a new
 * tab. Used in the franchises table and in the franchise (company) detail.
 */
export const FranchiseReportsLink = ({
  href,
  children,
  onClick,
}: FranchiseReportsLinkProps) => (
  <ExternalLink
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-test="franchiseReportsLink"
    onClick={onClick}
  >
    {children}
  </ExternalLink>
);
